import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PagesService } from '../../pages/pages.service';
import { Observable } from 'rxjs';
import { Router, RouterModule } from '@angular/router';
import { AuthRedirectService, AuthService, AuthStorageService } from '@spartacus/core';
import { SsoLogin } from '../../core/services/sso-login.service';
@Component({
  selector: 'app-jjsv-header',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './jjsv-header.component.html',
  styleUrl: './jjsv-header.component.scss',
})
export class JjsvHeader {

  readonly navNodes$: Observable<any>;
  loginStatus = true; // This should be dynamically set based on actual authentication state
  showLogoutPopover = false;
  constructor(
    private pagesService: PagesService, 
    private router: Router,
    private auth: AuthService, 
    private authRedirectService: AuthRedirectService,
    private authStorageService: AuthStorageService,
    private SsoLogin: SsoLogin
  ) {
    this.navNodes$ = this.pagesService.navigationNodes$;
  }

  onLogout(): void {
    this.showLogoutPopover = !this.showLogoutPopover;
  }

  closeLogoutPopover(): void {
    this.showLogoutPopover = false;
  }

  confirmLogout(): void {
    this.showLogoutPopover = false;
    this.pagesService.markActiveReviewCartLeft();
    this.auth.logout();
    this.authRedirectService.setRedirectUrl('/');
    this.authStorageService.removeItem('access_token');
    localStorage.removeItem('userId');
    
  }

  onNavLinkClick(path: string): void {
    if (path === '/purchase-orders') {
      this.pagesService.setPurchaseOrderTitle('ALL');
    }
  }
}
